export default __webpack_public_path__ + "static/media/icon_business_center.15325076.svg";